export default __webpack_public_path__ + "static/media/Group 3202@2x.4c36c516.png";